import { IAuthConfig, UserRole } from 'ee-common-lib';

export const CUSTOMER_AUTH_CONFIG: IAuthConfig = {
	loginUrl: '/login',
	defaultRole: UserRole.Customer
};
